import React from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonLinkOutstanding } from 'src/shared/components';

import styles from './HomeButtonsList.module.scss';

const HomeButtonsList = () => {
	const { t } = useTranslation();

	return (
		<div className={styles.actions}>
			<ButtonLinkOutstanding id="get_started_button" href="#about">
				{t('homeSection.buttons.getStarted')}
			</ButtonLinkOutstanding>
			<ButtonLinkOutstanding id="services_button" variant="outlined" href="#services">
				{t('homeSection.buttons.whatWeOffer')}
			</ButtonLinkOutstanding>
		</div>
	);
};

export default HomeButtonsList;
